// Appup Components 
import Timeline from './components/timeline';
import Html from './components/html';
import Timeago from './components/timeago';
import Avatar from './components/avatar';
import Image from './components/image';
import Link from './components/link';
import Table from './components/table';
import Button from './components/button';
import Alert from './components/alert';
import Datatable from './components/datatable';
import Code from './components/code';
import Navbar from './components/navbar';
import Modal from './components/modal';
import Accordion from './components/accordion';
import Tabs from './components/tabs';
import Header from './components/header';
import Grid from './components/grid';
import Listgrid from './components/listgrid';
import Workflowtabs from './components/workflowtabs';

// Card
import Card from './components/card';

// Form Input Components
import Hidden from './components/inputs/hidden';
import Radio from './components/inputs/radio';
import Checkbox from './components/inputs/checkbox';
import Textarea from './components/inputs/textarea';
import Dropdown from './components/inputs/dropdown';
import Multiselect from './components/inputs/multiselect';
import Tags from './components/inputs/tags';
import Editor from './components/inputs/editor';
import Input from './components/inputs/input';
import Datetime from './components/inputs/datetime';
import File from './components/inputs/file';
import Imageupload from './components/inputs/imageupload';

import Form from './components/form';

const Appup = {
    'appup-listgrid': Listgrid,
    'appup-grid': Grid,
    'appup-card': Card,
    'appup-header': Header,
    'appup-timeline': Timeline,
    'appup-html': Html,
    'appup-timeago': Timeago,
    'appup-avatar': Avatar,
    'appup-image': Image,
    'appup-table': Table,
    'appup-button': Button,
    'appup-link': Link,
    'appup-alert': Alert,
    'appup-tabs': Tabs,
    'appup-accordion': Accordion,
    'appup-datatable': Datatable,
    'appup-code': Code,
    'appup-navbar': Navbar,
    'appup-workflowtabs':Workflowtabs,
    // Form Input Components
    'appup-hidden': Hidden,
    'appup-radio': Radio,
    'appup-checkbox': Checkbox,
    'appup-dropdown': Dropdown,
    'appup-textarea': Textarea,
    'appup-editor': Editor,
    'appup-datetime': Datetime,
    'appup-file': File,
    'appup-multiselect': Multiselect,
    'appup-tags': Tags,
    'appup-input': Input,
    'appup-imageupload': Imageupload,

    'appup-form': Form,
    'appup-modal': Modal,

};

export default Appup;



// WEBPACK FOOTER //
// ./src/appup-components.js